import { checkDeviceResolution } from '../utils/check-device-resolution';
import 'sticky-kit/dist/sticky-kit';

const $window = $(window);
const $product = $('.js-product-single');
const $productImage = $('.js-product-image');
const $productContent = $('.js-product-content');

$productImage.stick_in_parent();

if ($('.product-single').length) {
  const resizeOb = new ResizeObserver(function (element) {
    let rect = element[0].contentRect;

    let width = rect.width;
    let height = rect.height;

    $productImage.trigger('sticky_kit:recalc');
  });

  // start observing for resize
  resizeOb.observe(document.querySelector('.js-accordion'));

  $window.on('load resize orientationchange', function(){
    $productImage.toggleClass('product__images--alt', ($window.height() > $productContent.outerHeight()))
  })
}
